import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {
  OrganizationModel,
  OrganizationBlockModel
} from './organization.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class OrganizationService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetOrganizationList(input?: DataListModel): Observable<IAPIResponse> {
    let getOrganizationUrl = WeGoConfig.API_GET_ORGANIZATION_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getOrganizationUrl = getOrganizationUrl + '?' + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportOrganizationList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_ORGANIZATION_LIST + '?' + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public GetOrganizationByHashId(
    organizationHashId: string
  ): Observable<IAPIResponse> {
    let getCompnayUrl =
      WeGoConfig.API_GET_ORGANIZATION_BY_HASH +
      '?organizationHashId=' +
      organizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompnayUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationBasicDetail(
    organizationHashId: string
  ): Observable<IAPIResponse> {
    let getCompnayUrl =
      WeGoConfig.API_GET_ORGANIZATION_BASIC_DETAIL +
      '?organizationHashId=' +
      organizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompnayUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddOrganization(
    organizationModel: OrganizationModel
  ): Observable<IAPIResponse> {
    let body = organizationModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_ORGANIZATION_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteOrganization(
    selectedOrganizationList: string[]
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        WeGoConfig.API_POST_DELETE_ORGANIZATION,
        selectedOrganizationList,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public UpdateOrganizationContactPerson(
    organizationHashId: string,
    personHashId: string
  ): Observable<IAPIResponse> {
    let getOrganizationUrl =
      WeGoConfig.API_UPDATE_ORGANIZATION_CONTACT_PERSON +
      '?organizationHashId=' +
      organizationHashId +
      '&personHashId=' +
      personHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPersonListForContactPerson(
    organizationMasterHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getPersonUrl = WeGoConfig.API_GET_ORGANIZATION_CONATACT_PERSON_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getPersonUrl =
        getPersonUrl +
        '?' +
        queryString +
        '&organizationHashId=' +
        organizationMasterHashId;
    } else {
      getPersonUrl =
        getPersonUrl + '?organizationHashId=' + organizationMasterHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public RemocveOrganizationContactPerson(
    organizationHashId: string
  ): Observable<IAPIResponse> {
    let getComapanyUrl =
      WeGoConfig.API_REMOVE_ORGANIZATION_CONTACT_PERSON +
      '?organizationHashId=' +
      organizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getComapanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public InActiveOrganizationAdmin(companyAdminHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_INACTIVE_COMPANY_ADMIN +
      '?companyAdminHashId=' +
      companyAdminHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationDriverList(
    organizationHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getOrganizationDriverList = WeGoConfig.API_GET_ORGANIZATION_DRIVER_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getOrganizationDriverList =
        getOrganizationDriverList +
        '?' +
        queryString +
        '&organizationHashId=' +
        organizationHashId;
    } else {
      getOrganizationDriverList =
        getOrganizationDriverList + '?organizationHashId=' + organizationHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getOrganizationDriverList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportOrganizationDriverList(
    organizationHashId: string,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let getOrganizationDriverList =
      WeGoConfig.API_EXPORT_ORGANIZATION_DRIVER_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getOrganizationDriverList =
        getOrganizationDriverList +
        '?' +
        queryString +
        '&organizationHashId=' +
        organizationHashId;
    } else {
      getOrganizationDriverList =
        getOrganizationDriverList + '?organizationHashId=' + organizationHashId;
    }
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getOrganizationDriverList, options);
  }

  // public GetOrganizationForBatchUpload(input?: DataListModel): Observable<IAPIResponse> {
  //     let getOrganizationUrl = WeGoConfig.API_GET_ORGANIZATION_FOR_BATCH_UPLOAD;
  //     let headers = this.authService.GetHeader();
  //     let options = new RequestOptions({ headers: headers });
  //     return this.http.get(getOrganizationUrl, options)
  //         .map(this.authService.HandleAPIResponse)
  //         .catch(this.authService.HandleAPIError);
  // }

  // public GetOrganizationListByInstance(instanceHashId: string): Observable<IAPIResponse> {
  //     let getOrganizationUrl = WeGoConfig.API_GET_ORGANIZATION_LIST_BY_INSTANCE;
  //     getOrganizationUrl = getOrganizationUrl + "?instanceHashId=" + instanceHashId;
  //     let headers = this.authService.GetHeader();
  //     let options = new RequestOptions({ headers: headers });
  //     return this.http.get(getOrganizationUrl, options)
  //         .map(this.authService.HandleAPIResponse)
  //         .catch(this.authService.HandleAPIError);
  // }

  public GetOrganizationListDropdownForAddUpdatePage(
    pageName: string,
    permissionType: string,
    instanceHashId?: string,
    companyHashId?: string
  ): Observable<IAPIResponse> {
    let getOrganizationUrl: string;
    switch (pageName) {
      case 'SignupFormConfig':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_SIGNUPCONFIG;
        break;
      case 'BatchUploadPerson':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BATCHUPLOADPERSON;
        break;
      case 'Template':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_TEMPLATE;
        break;
      case 'Terms_And_Condition':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_TERMS_AND_CONDITION;
        break;
      default:
        getOrganizationUrl = WeGoConfig.API_GET_ORGANIZATION_LIST;
        break;
    }
    if (permissionType) {
      getOrganizationUrl =
        getOrganizationUrl + '?permissionType=' + permissionType;
    }
    if (instanceHashId) {
      getOrganizationUrl =
        getOrganizationUrl + '&instanceHashId=' + instanceHashId;
    }
    if (companyHashId) {
      getOrganizationUrl =
        getOrganizationUrl + '&companyHashId=' + companyHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownOrganizationListByCompanyIdList(
    reportName: string,
    permissionType: string,
    companyHashIds: string[]
  ): Observable<IAPIResponse> {
    let getOrganizationUrl: string;

    switch (reportName) {
      case 'Terms_And_Condition':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BY_COMPANY_LIST_TERMS_AND_CONDITION;
        break;
    }

    if (permissionType) {
      getOrganizationUrl =
        getOrganizationUrl + '?permissionType=' + permissionType;
    }

    let queryString = '';
    companyHashIds.forEach(element => {
      queryString += '&companyHashIdList=' + element;
    });

    getOrganizationUrl = getOrganizationUrl + queryString;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCompanyList(input?: DataListModel): Observable<IAPIResponse> {
    let getCompanyUrl = WeGoConfig.API_GET_ORGANIZATION_COMPANY_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getCompanyUrl = getCompanyUrl + '?' + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompanyUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSVGBaseOrganizationDropDown(
    pageName: string,
    instanceHashId?: string,
    companyHashId?: string,
    sharedVehicleGroupHashId?: string
  ): Observable<IAPIResponse> {
    let getOrganizationUrl: string;
    switch (pageName) {
      case 'Kick_Back_Report':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_KICK_BACK_REPORT;
        break;
      case 'Cost_Center_Report':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_COST_CENTER_REPORT;
        break;
      case 'TripData_Report':
        getOrganizationUrl =
          WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_TRIP_DATA_REPORT;
        break;
      default:
        getOrganizationUrl = WeGoConfig.API_GET_ORGANIZATION_LIST;
        break;
    }

    if (instanceHashId) {
      getOrganizationUrl =
        getOrganizationUrl + '?instanceHashId=' + instanceHashId;
    }
    if (companyHashId) {
      getOrganizationUrl =
        getOrganizationUrl + '&companyHashId=' + companyHashId;
    }
    if (sharedVehicleGroupHashId) {
      getOrganizationUrl =
        getOrganizationUrl +
        '&sharedVehicleGroupHashId=' +
        sharedVehicleGroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationGDPRSettings(
    organizationHashId: string
  ): Observable<IAPIResponse> {
    let getCompnayUrl =
      WeGoConfig.API_GET_ORGANIZATION_GDPR_SETTINGS +
      '?organizationHashId=' +
      organizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCompnayUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public BlockUnblockOrganization(
    organizationBlockModel: OrganizationBlockModel
  ): Observable<IAPIResponse> {
    let body = organizationBlockModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(WeGoConfig.API_POST_ORGANIZATION_BLOCKUNBLOCK, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaCookies(OrganizationHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_COOKIES_ORGANIZATION + "?OrganizationHashId=" + OrganizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaKeys(OrganizationHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_KEYS_ORGANIZATION + "?OrganizationHashId=" + OrganizationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organization/models/organization.service.ts